import { HelpCircle } from "lucide-react";
import { Button, TooltipTrigger } from "react-aria-components";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from "react-hook-form";

import { Switch } from "@/components/switch";
import { Tooltip } from "@/components/tooltip";

type AiAssetsToggleProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  onValueChange?: (value: boolean) => void;
};

export function AiAssetsToggle<T extends FieldValues>({
  control,
  name,
  onValueChange,
}: AiAssetsToggleProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <div className="flex items-center gap-sm">
          <Switch
            isSelected={!!value}
            onChange={(isSelected) => {
              onChange(isSelected);
              onValueChange?.(isSelected);
            }}
          >
            Do not use AI Assets
          </Switch>
          <TooltipTrigger delay={0}>
            <Button
              aria-label="More information about AI assets"
              className="cursor-default outline-hidden"
            >
              <HelpCircle className="size-4 text-fg-quinary" />
            </Button>
            <Tooltip>
              By turning this on, the design team will not use AI-generated
              assets in this request. You can turn this off at any time.
            </Tooltip>
          </TooltipTrigger>
        </div>
      )}
    />
  );
}
